module.exports = {
  "id": 402193,
  "images": [
    {
      "url": require("./cat-img.jpeg"),
    },
    {
      "url": "http://apresentation.com/wp-content/uploads/2017/11/BLG_Andrew-G.-River-Sample_09.13.12.png",
    },
    {
      "url": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    },
  ],
  "backs": [
    {
      "id": 1,
      name: "cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat ",
      "image": require("./cat-img.jpeg"),
    },
    // {
    //   "id": 2,
    //   name: "dog",
    //   "image": require("./dog-img.jpeg"),
    // },
    // {
    //   "id": 3,
    //   name: "aaa",
    //   "image": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    // },
    // {
    //   "id":4,
    //   name: "cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat ",
    //   "image": require("./cat-img.jpeg"),
    // },
    // {
    //   "id":5,
    //   name: "dog",
    //   "image": require("./dog-img.jpeg"),
    // },
    // {
    //   "id":6,
    //   name: "aaa",
    //   "image": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    // },
    // {
    //   "id":7,
    //   name: "cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat ",
    //   "image": require("./cat-img.jpeg"),
    // },
    // {
    //   "id":8,
    //   name: "dog",
    //   "image": require("./dog-img.jpeg"),
    // },
    // {
    //   "id":9,
    //   name: "aaa",
    //   "image": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    // },
    // {
    //   "id":10,
    //   name: "cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat ",
    //   "image": require("./cat-img.jpeg"),
    // },
    // {
    //   "id":11,
    //   name: "dog",
    //   "image": require("./dog-img.jpeg"),
    // },
    // {
    //   "id":12,
    //   name: "aaa",
    //   "image": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    // },
    // {
    //   "id":13,
    //   name: "cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat cat ",
    //   "image": require("./cat-img.jpeg"),
    // },
    // {
    //   "id":14,
    //   name: "dog",
    //   "image": require("./dog-img.jpeg"),
    // },
    // {
    //   "id": 15,
    //   name: "aaa",
    //   "image": "http://www.hockadaymuseum.org/userfiles/image/Exhibitions%202017/Michael_Sample_Apikuni_Mountain_GNP_undated_e.jpg",
    // },
  ],

    "product": {
        "name": "5.5 x 8.5 Large Postcard",
        "idProductType": 2
    },
    "variationOptionFields": [],
    "variations": []
};